module.exports = __webpack_public_path__ + "img/613F04_D68C04_A45F04_1F0F04-256px.c963958a.png";